export const SDK_VERSION = '4.0.0';
export const SDK_NAME = 'react-native-sdk';
